import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Card, Typography, Stack, Button, IconButton, Box } from '@mui/material';
// utils
import { fCurrency } from '../../../../utils/formatNumber';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  position: 'relative',
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.common.white,
  padding: theme.spacing(3),
  borderRadius: 24,
  boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.3)}`,
  overflow: 'hidden',
  '&:before': {
    content: '""',
    position: 'absolute',
    top: -50,
    right: -50,
    width: 150,
    height: 150,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.1)',
  }
}));

// ----------------------------------------------------------------------

YangaBalanceCard.propTypes = {
  balance: PropTypes.number,
  onFund: PropTypes.func,
};

export default function YangaBalanceCard({ balance, onFund }) {
  const [showBalance, setShowBalance] = useState(true);

  return (
    <RootStyle>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle2" sx={{ opacity: 0.8, fontWeight: 600 }}>
              Available Balance
            </Typography>
            <IconButton size="small" onClick={() => setShowBalance(!showBalance)} sx={{ color: 'inherit' }}>
              <Iconify icon={showBalance ? 'eva:eye-fill' : 'eva:eye-off-fill'} width={16} height={16} />
            </IconButton>
          </Stack>
          <IconButton size="small" sx={{ color: 'inherit', bgcolor: 'rgba(255,255,255,0.1)' }}>
            <Iconify icon="eva:refresh-outline" width={16} height={16} />
          </IconButton>
        </Stack>

        <Typography variant="h3" sx={{ fontWeight: 800, fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' } }}>
          {showBalance ? `₦${fCurrency(balance)}` : '****'}
        </Typography>

        <Button
          fullWidth
          variant="contained"
          onClick={onFund}
          sx={{
            bgcolor: 'common.white',
            color: 'primary.main',
            borderRadius: '12px',
            py: 1.5,
            fontWeight: 700,
            fontSize: '1rem',
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.9)',
            },
          }}
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          Add Funds
        </Button>
      </Stack>
    </RootStyle>
  );
}
